import { NewsClass } from "../../components/newsData";
import {
  ButtonsContainer,
  CardsContainer,
  NewsCard,
  Wrapper,
} from "./news.styled";
import img from "../../assets/Bitmap.png";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { NavLink } from "../FAQ/FAQ.styled";
import { ButtonPrimary } from "@components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import General from "../../stores/GeneralStore";
const News = () => {
  const [type, setType] = useState("all");
  const [chosen, setChosen] = useState("all");
  const handleEvents = (e: any) => {
    setType(e.target.value);
    setChosen(e.target.value);
  };
  const navigate = useNavigate();

  const toIdPage = (id: any) => {
    navigate(`/news/${id}`);
  };

  const Data: NewsClass[] = [
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "News",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
    {
      image: img,
      date: "data",
      title: "title title title",
      data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto",
      type: "Events",
    },
  ];

  const handleClick = () => { };

  return (
    <>
      <MoveInHeader>
        <div style={{ width: "90%", margin: "0 auto" }}>
          <MiniNav>
            <NavLink to="/">
              {General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : "home"}

            </NavLink>&nbsp;/&nbsp;
            <NavLink to="/">Media Center</NavLink>&nbsp;/&nbsp;
            <NavLink to="/">News & Events</NavLink>
          </MiniNav>
          <h1>News & Events</h1>
        </div>
      </MoveInHeader>
      <Wrapper>
        <ButtonsContainer>
          <ButtonPrimary
            value="all"
            name="all"
            onClick={handleEvents}
            label="All"
            children={
              chosen === "all" ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowDropDownIcon sx={{ visibility: "hidden" }} />
              )
            }
          />
          <ButtonPrimary
            value="Events"
            name="events"
            onClick={handleEvents}
            label="Events"
            children={
              chosen === "Events" ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowDropDownIcon sx={{ visibility: "hidden" }} />
              )
            }
          />
          <ButtonPrimary
            value="News"
            name="news"
            onClick={handleEvents}
            label="News"
            children={
              chosen === "News" ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowDropDownIcon sx={{ visibility: "hidden" }} />
              )
            }
          />
        </ButtonsContainer>
        <CardsContainer>
          {/* <img src={Data[0].image} /> */}
          {Data.map((data: NewsClass, index: any) => (
            <>
              {type === "all" && (
                <NewsCard key={index} onClick={() => toIdPage(index + 1)}>
                  <img src={data.image} alt="" />
                  <section>
                    <div className="title">
                      <span>{data.date}</span>
                      <button
                        disabled
                        style={{ background: "#fff", color: "#eee" }}
                      >
                        {General?.codeLabels["cm_mob_news"]?.label !== undefined ? General?.codeLabels["cm_mob_news"]?.label : "News"}
                      </button>
                    </div>
                    <b>{data.title}</b>
                    <span style={{ fontSize: ".8rem" }}>{data.data}</span>
                  </section>
                </NewsCard>
              )}
              {data.type === type && (
                <NewsCard key={index}>
                  <img src={data.image} alt="" />
                  <section>
                    <div className="title">
                      <span>{data.date}</span>
                      <button
                        disabled
                        style={{ background: "#fff", color: "#eee" }}
                      >
                        {General?.codeLabels["cm_mob_news"]?.label !== undefined ? General?.codeLabels["cm_mob_news"]?.label : "News"}

                      </button>
                    </div>
                    <b>{data.title}</b>
                    <span style={{ fontSize: ".8rem" }}>{data.data}</span>
                  </section>
                </NewsCard>
              )}
            </>
          ))}
        </CardsContainer>
        <ButtonPrimary onClick={handleClick} label="Load More..." />
      </Wrapper>
    </>
  );
};

export default News;
